import classNames from 'classnames';
import React from 'react';

import { IconTypes } from '@eika/icon';
import { ErrorLabel, Label, WarningLabel } from '@eika/label';

import useTranslation from '../../hooks/useTranslation';
import { PaymentLimitsErrorMessage } from '../shared/PaymentLimitsErrorMessage';

import './AmountBox.scss';

interface Props extends React.PropsWithChildren {
    isNoCoverage: boolean;
    domesticPaymentWarning?: boolean;
    error?: string;
    limitError?: string;
    limitWarning?: string | null;
    label?: ReturnType<typeof Label> | boolean;
    className?: string;
    locked?: boolean;
}

const AmountBox: React.FC<Props> = ({
    isNoCoverage,
    domesticPaymentWarning,
    error,
    limitError,
    limitWarning,
    label,
    className,
    children,
    locked = false,
}) => {
    const translated = useTranslation();

    return (
        <div className={classNames('amount-box__container', className)}>
            <div className={classNames('amount-box', { 'amount-box__locked': locked }, className)}>{children}</div>
            {(!!error || !!label) && (
                <div className="amount-box__minAmount">
                    {error ? <ErrorLabel icon={IconTypes.UTROPSTEGN_24} text={error} /> : label}
                </div>
            )}
            {!error && limitError && (
                <PaymentLimitsErrorMessage className="amount-box__error-container" message={limitError} />
            )}
            {!error && limitWarning && !limitError && !isNoCoverage && (
                <PaymentLimitsErrorMessage
                    className="amount-box__error-container"
                    message={limitWarning}
                    type="warning"
                />
            )}
            {!error && !limitError && isNoCoverage && (
                <div className="amount-box__error-container">
                    <WarningLabel text={translated.notEnoughInAccount} />
                </div>
            )}
            {!error && !limitError && !isNoCoverage && !limitWarning && domesticPaymentWarning && (
                <div className="amount-box__error-container">
                    <WarningLabel text={translated.crossBorderPayment.domesticPaymentWarning} />
                </div>
            )}
        </div>
    );
};

export default AmountBox;
